import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { QrCode } from '../../../../../../components/qr-code/qr-code';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQrStaffStore } from '../../../../../../store/use-qr-employee-store';
import s from './qr-code-employee-modal.module.css';

export const QrCodeEmployeeModal = (props: ModalProps) => {
  const { t } = useLang();
  const {
    fetchLoginQr,
    fetchRegisterQr,
    isLoadingFetch: isLoading,
    loginQr,
    registerQr,
  } = useQrStaffStore();
  const [params] = useSearchParams();
  const id = params.get('id');
  const type = params.get('type');

  useEffect(() => {
    if (!id) {
      return;
    }
    if (type === 'register') {
      fetchRegisterQr(id);
    } else {
      fetchLoginQr(id);
    }
  }, [fetchLoginQr, fetchRegisterQr, id, type]);

  const isRegister = type === 'register';

  const bottomLabel = isRegister
    ? t('Покажите QR-код сотруднику, чтобы он смог зарегистрироваться')
    : t('Покажите QR-код сотруднику, чтобы он смог войти в систему');
  const qr = isRegister ? registerQr : loginQr;
  const parsedQr = JSON.parse(qr || '{}');
  const qrValue = isRegister ? JSON.stringify(parsedQr.qr_content) : parsedQr.token;

  return (
    <Modal {...props} title={t('QR-код сотрудника')} className={s.feature}>
      <label>{t('QR-код сотрудника {{staffName}}', { staffName: params.get('staffName') })}</label>
      <QrCode data={qrValue} isLoading={isLoading} />
      <label>{bottomLabel}</label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Назад')}
        </Button>
      </div>
    </Modal>
  );
};
